import {TranslateService} from '@ngx-translate/core';
import {type SmContextMenuItemModel} from '../components/sm-context-menu-item/sm-context-menu-item.component';

export const PRODUCT_CONTAINER_MENU_ARIA_LABEL_KEY = 'contextMenu.containerAriaLabel';

export const PRODUCT_CONTAINER_MENU_ITEMS: SmContextMenuItemModel[] = [
  {id: 'edit', textKey: 'contextMenu.containerActions.edit', iconName: 'pencil-outline'},
  {id: 'share', textKey: 'contextMenu.containerActions.share', iconName: 'share-outline'},
  {id: 'move', textKey: 'contextMenu.containerActions.move', iconName: 'inventory-move'},
  {id: 'move-into', textKey: 'contextMenu.containerActions.moveInto', iconName: 'inventory-move-into'},
  {id: 'new', textKey: 'contextMenu.containerActions.new', iconName: 'file-tray-outline'},
  {id: 'numbered-subcontainers', text: '+ 1…N', ariaLabelKey: 'containers.page.numbered.actionTooltip', iconName: 'apps-outline'},
  {id: 'delete', textKey: 'contextMenu.containerActions.delete', iconName: 'trash-outline'},
];

export function buildContainerMenuAriaLabel(
  translateService: TranslateService,
  name: string,
): string {
  return translateService.instant(PRODUCT_CONTAINER_MENU_ARIA_LABEL_KEY, {name});
}
